import { render } from "./StudentsGroups.vue?vue&type=template&id=4cc3fd16"
import script from "./StudentsGroups.vue?vue&type=script&lang=js"
export * from "./StudentsGroups.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__